<template>
  <div class="app-shell">
    <!-- Public Nav (Only for landing/auth, hidden for dashboard/room) -->
    <nav class="nav" v-if="!isDashboard && !isRoomPublic">
      <div class="brand">
        <img alt="لوگو" src="./assets/logo.png">
        <span>پویش کیدز</span>
      </div>
      <div class="links">
        <template v-if="!isLoggedIn">
          <router-link to="/login">ورود</router-link>
          <router-link to="/register">ثبت‌نام</router-link>
        </template>
        <template v-else>
          <router-link to="/dashboard">پنل کاربری</router-link>
        </template>
      </div>
    </nav>
    
    <!-- Main Content -->
    <main class="content" :class="{ 'no-pad': isDashboard || isRoomPublic }">
      <router-view />
    </main>
    
    <Toast />
  </div>
</template>

<script>
import Toast from './components/Toast.vue'

export default {
  name: 'App',
  components: { Toast },
  computed: {
    isDashboard() {
      return this.$route.path.startsWith('/dashboard')
    },
    isRoomPublic() {
      return this.$route.path.startsWith('/room/')
    },
    isLoggedIn() {
      const t = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')
      return !!t
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;600;700;900&display=swap');

:root {
  --bg: #f8fafc;
  --text: #1e293b;
  --primary: #2563eb;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Vazirmatn', sans-serif;
  background: var(--bg);
  color: var(--text);
  direction: rtl;
}

.app-shell {
  min-height: 100vh;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}
.brand { display:flex; align-items:center; gap:10px; font-weight:700; font-size: 18px; }
.brand img { height:32px; width:auto; }

.content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px;
}
.content.no-pad {
  max-width: none;
  margin: 0;
  padding: 0;
}

input { text-align: right; } /* Default RTL friendly inputs */
input[type="email"], input[type="password"], input.ltr { direction: ltr; text-align: left; }

/* Global Custom Scrollbar */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #cbd5e1; /* Slate-300 matching existing palette tone */
  border-radius: 999px;
  border: 3px solid transparent; /* Creates padding around the thumb */
  background-clip: content-box;
  transition: background-color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--primary);
}

/* For Firefox */
* {
  --scroll-size: 5px;
  --scroll-radius: 10px;
  --scroll-track: rgb(255 255 255 / 10%);
  --scroll-thumb-color: #fff;
}
</style>
